import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IceDatabaseService } from '../../../../services/ice-database.service';
import { DefaultFilter, IceDatabaseDetail } from '../../models/ice-database.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IceapiService, UserUtilityService } from 'src/app/services';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-ice-database-content',
    templateUrl: './ice-database-content.component.html',
    styleUrls: ['./ice-database-content.component.scss'],
})
export class IceDatabaseContentComponent implements OnInit, OnDestroy {
    @Input() databaseDetails: IceDatabaseDetail[];
    destroy$ = new Subject();
    selectedData: IceDatabaseDetail;
    copySelectedData: IceDatabaseDetail;
    searchInput: string;
    selectedTable: string;
    selectedFilter: DefaultFilter;

    constructor(
        private iceDatabaseService: IceDatabaseService,
        private iceapiService: IceapiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.handleSubscription();
    }

    handleSubscription(): void {
        this.iceDatabaseService.selectedTableItems.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.selectedTable = null;
                this.iceDatabaseService.selectedTableName.next({ tableName: this.selectedTable });
                this.selectedData = { name: res.tableData.name, tableList: res.tableData.tableList.slice() };
                this.copySelectedData = { name: res.tableData.name, tableList: res.tableData.tableList.slice() };
            } else {
                this.selectedData = null;
                this.selectedTable = null;
            }
        });

        this.iceDatabaseService.selectedTableName.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.selectedTable = res.tableName;
                this.selectedFilter = res.fieldName && res.id ? { fieldName: res.fieldName, id: res.id } : null;
                this.cd.detectChanges();
            }
        });

        this.ngxUiLoaderService.start();
        this.iceapiService
            .getIceDatabaseRefrences()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    if (res.success === true) {
                        this.iceDatabaseService.tableRefrences = res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                    this.ngxUiLoaderService.stop();
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                    this.user_utility.errorModelPopup(err.message);
                }
            );
    }

    selectedTableItem(selectedItem: IceDatabaseDetail): void {
        this.iceDatabaseService.selectedTableItems.next({ tableData: selectedItem });
    }

    searchResult(event): void {
        if (this.searchInput.trim() !== '') {
            this.copySelectedData.tableList = this.selectedData.tableList.filter((item) => {
                return (item.name !== undefined ? item.name : '').toLowerCase().includes(this.searchInput.trim().toLowerCase());
            });
        } else {
            this.copySelectedData.tableList = [...this.selectedData.tableList];
        }
    }

    selectedTableName(tableName: string): void {
        this.iceDatabaseService.selectedTableName.next({ tableName: tableName });
    }
    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
